<div *ngIf="!enableCreditOffers" class="col-md-12" role="status">
  
    <h3>BCT is not accepting any offers at the moment</h3>
  
</div>
<div *ngIf="enableCreditOffers" class="d-flex">
  <div class="col-md-12">
    <div class="col md-12">
      <div class="mb-3 w-50"><h5>Credit Offer Portal - Wanted Credits <span style="padding-left:50px">UPDATED 25/03/2025</span></h5></div>
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem>
          <a ngbNavLink>Instructions</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body">
                <h5 class="text-info">Welcome to the Credit Offer Portal</h5>
                <div class="mt-2">
                  <p>The Credit Offer Portal enables participants to:</p>
                  <ul>
                    <li>Browse through the BCT's Wanted Credits List</li>
                    <li>Select credit types to be offered for sale to the BCT, and</li>
                    <li>Submit an offer to sell their credits to the BCT</li>
                  </ul>
                  <p>
                    The BCT’s <a href="https://www.bct.nsw.gov.au/credit-offer-portal" target="_blank">Credit Offer Portal</a> webpage provides information on how to use the Wanted Credits List.
                  </p>
                  <p>
                    Please refer to the Guide to the Credit Offer portal before using the Wanted credits list and submitting an offer etc.
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Ecosystem Credits</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body">
                <p>
                  Use this table to search for ecosystem credits wanted by the BCT.
                  Refer to the BCT <a href="https://www.bct.nsw.gov.au/credit-offer-portal" target="_blank">Credit Offer Portal</a> webpage for more information.
                </p>
                <p>
                  <strong>Note:</strong> All four question fields below must be completed with information that matches the credits you own. Not doing so may result in your offer application being ineligible and rejected.
                </p>
                <app-search #ecoList [category]="'ecosystem'"></app-search>
              </div>
              <div class="card-footer">
                <button  class="btn btn-primary" (click)="createOffer('E');">Create offer</button><span class="text-info ml-1">Users are required to create an account before creating an offer.</span>
                <span *ngIf="!enableOfferSumbission" class="text-danger ml-3">BCT is not accepting any offers at the moment.</span>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Species Credits</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body">
                <div class="col mb-2">
                  <p>
                    <strong>Table 2A - Species credits wanted anywhere in NSW</strong>
                    <br />
                    Use this table to search for species credits wanted by the BCT.
                    If you can't find the species credits you have available in this table, or you have
                    more credits than listed in this table then go to Table 2B.
                    <br />Refer to the Biodiversity Credits Wanted page for more information.
                  </p>
                </div>
                <app-search #speciesList [category]="'species'"></app-search>
              </div>
              <div class="card-footer">
                <button [disabled]="!enableSubmitButton" class="btn btn-primary" (click)="createOffer('S');">Create offer</button><span class="text-info ml-1">Users are required to create an account before creating an offer.</span>
                <span *ngIf="!enableOfferSumbission" class="text-danger ml-3">BCT is not accepting any offers at the moment.</span>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem>
          <a ngbNavLink>Species Credits (variations)</a>
          <ng-template ngbNavContent>
            <div class="card">
              <div class="card-body">
                <div class="col">
                  <p>
                    <strong>Table 2B - Species credits wanted anywhere in specific IBRA subregions</strong>
                    <br />
                    Use this table if you can't find your species credits in Table 2A or you can find your species credits
                    however you have more credits available for sale than the number wanted in Table 2A.
                    <br />Refer to the Biodiversity Credits Wanted page for more information.
                    <br /><i>Note that table 2B does not display any wanted credits at present</i>
                  </p>
                </div>
                <app-search #speciesList2 [category]="'speciesv'"></app-search>
              </div>
              <div class="card-footer">
                <button [disabled]="!enableSubmitButton" class="btn btn-primary" (click)="createOffer('S2');">Create offer</button><span class="text-info ml-1">Users are required to create an account before creating an offer.</span>
                <span *ngIf="!enableOfferSumbission" class="text-danger ml-3">BCT is not accepting any offers at the moment.</span>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>


  </div>
</div>
